import { render, staticRenderFns } from "./merchant-accounts-container.vue?vue&type=template&id=ecf17f46&scoped=true&lang=pug"
import script from "./merchant-accounts-container.vue?vue&type=script&lang=ts"
export * from "./merchant-accounts-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf17f46",
  null
  
)

export default component.exports